/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from "../services";

interface SwitchResponse {
  data: {
    data: any; // You might want to define a more specific type here based on your actual data structure
  };
}

interface SwitchParams {
  // Define the structure of your params here
  [key: string]: any;
}

export const adminActions = {
  getSwitches,
  updateSwitches,
};

function getSwitches(): Promise<any> {
  const response = services.get<SwitchResponse>(`/admin/dashboard/list`);
  return response.then((promise) => {
    if (promise && "data" in promise) {
      // Type guard to check if it's a successful response
      return promise.data.data;
    } else {
      return Promise.reject("Error fetching switches");
    }
  });
}

function updateSwitches(
  id: string | number,
  params: SwitchParams,
): Promise<any> {
  const response = services.put<SwitchResponse>(
    `/admin/dashboard/update/${id}`,
    params,
  );
  return response.then((promise) => {
    if (promise && "data" in promise) {
      return promise.data;
    } else {
      return Promise.reject("Error updating switches");
    }
  });
}
